const values = [
  {
    icon: 'ri-fire-line',
    title: 'Forged for Results',
    description:
      'Every feature we ship is measured by one thing: does it help our users run better ads? We obsess over outcomes, not outputs.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Built on Trust',
    description:
      'Transparent pricing, honest AI limitations, no dark patterns. We treat our users like partners — because that\'s what they are.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Speed is a Feature',
    description:
      'We know your time is your most valuable asset. AdForge is designed to go from idea to polished ad in under two minutes.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Always Improving',
    description:
      'Our AI models are retrained on fresh performance data every month. The tool you use today will be smarter next week.',
  },
  {
    icon: 'ri-heart-3-line',
    title: 'Small Business First',
    description:
      'We\'re not built for Fortune 500 marketing departments. We\'re built for the people who work hardest and deserve the best tools.',
  },
  {
    icon: 'ri-global-line',
    title: 'Platform Agnostic',
    description:
      'Google, Facebook, Instagram, TikTok — wherever your customers are, AdForge meets you there with platform-native ad formats.',
  },
];

export default function AboutValues() {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
            What We Stand For
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-stone-900 mb-4">
            The values that drive us
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            These aren't values we put on a wall — they're the decisions we make every day when building AdForge.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((v) => (
            <div
              key={v.title}
              className="bg-white rounded-2xl p-7 border border-stone-100 hover:border-orange-200 transition-all duration-300 group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-50 border border-orange-100 mb-5 group-hover:bg-orange-500 group-hover:border-orange-500 transition-all duration-300">
                <i className={`${v.icon} text-orange-500 text-lg group-hover:text-white transition-colors duration-300`} />
              </div>
              <h3 className="text-base font-bold text-stone-800 mb-2">{v.title}</h3>
              <p className="text-sm text-stone-500 leading-relaxed">{v.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
